export default "__VITE_ASSET__JfLCUgs___"